export default "__VITE_ASSET__DAn_ko7i__"